import { Theme, alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function paper(theme: Theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          transition: 'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease',
        },
        outlined: {
          borderColor: theme.palette.mode === 'dark' ? theme.palette.divider : alpha(theme.palette.grey[500], 0.16),
        },
      },
    },
  };
}
